
const AboutHero = () => {
  return (
    <section className="w-full bg-warmWhite border-b border-charcoal/10 py-6 sm:py-10 px-4 sm:px-6">
      <div className="max-w-6xl mx-auto flex items-center gap-4 sm:gap-6">
        <div className="flex items-center gap-2 sm:gap-3">
          <div className="w-5 sm:w-8 h-[1px] bg-charcoal/30"></div>
          <span className="text-charcoal/40 text-[9px] sm:text-[10px] font-sans font-semibold tracking-[0.35em] sm:tracking-[0.45em] uppercase whitespace-nowrap">
            About Us
          </span>
        </div>
        <h1 className="font-display text-xl sm:text-3xl sm:text-4xl font-light text-charcoal italic leading-snug">
          Vionne Clinical Atelier
        </h1>
        <div className="flex-1 h-[1px] bg-charcoal/10 hidden sm:block"></div>
        <p className="text-[12px] font-sans font-light text-textGray leading-relaxed tracking-wide max-w-xs hidden lg:block">
          A refined practice dedicated to structural recalibration through nervous system regulation.
        </p>
      </div>
    </section>
  );
};

export default AboutHero;
